import { useEffect, useRef } from "react";
import { TweenLite, Power2 } from 'gsap';
import CSSPlugin from 'gsap/CSSPlugin';

export const useHeaderAnimation = () => {
  const headerRef = useRef(null);
  const subheaderRef = useRef(null);
  const halfBoxRef = useRef(null);

  const reveal = (ref: HTMLElement, delay: number, duration: number) => {
    TweenLite.fromTo(
      ref,  
      { yPercent: 115 }, 
      { yPercent: 0, duration, delay, ease: Power2.easeOut },
    );
  };

  useEffect(() => {
    reveal(subheaderRef.current, 0.3, 0.9);
    reveal(headerRef.current, 0.3, 1);
    TweenLite.fromTo(
      halfBoxRef.current, 
      { xPercent: 100 }, 
      { xPercent: 0, delay: 0.7, duration: 1.1, ease: Power2.easeOut }
    );
  }, []);

  return {
    headerRef, 
    subheaderRef,
    halfBoxRef,
  };
};
